
import USRComponentListEditor from '@/components/USRComponentListEditor.vue'
import ManagementLayout from '@/layout/ManagementLayout.vue'
import { Activity, usrState, usrPreviewState, updateResource } from '@/model'
import { addToArray, removeFromArray } from '@/utils'
import { Close, Plus } from '@element-plus/icons'
import { defineComponent, reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ElLoading } from 'element-plus'
import api from '@/api'
import ImageUploader from '@/components/ImageUploader.vue'

interface State {
  editing: boolean;
  editingData: Activity;
  previewImageUrl: string;
}

export default defineComponent({
  name: 'ManageActivityPage',
  components: {
    Close,
    Plus,
    USRComponentListEditor,
    ImageUploader,
  },
  created() {
    this.$emit('update:layout', ManagementLayout)
  },
  setup() {
    const route = useRoute()
    const pId = route.params.id as string
    const isNew = pId === 'new'

    const dmTemplate = { imgSrc: '' }

    const editingData = getEditingData()

    function getEditingData(): Activity {
      return (isNew ? {
        timestamp: new Date(),
        imgUrl: '',
        title: '',
        local: '',
        time: '',
        dmList: [],
        components: [],
      } : usrState.activities.find(activity => activity.id === parseInt(pId, 10))) as Activity
    }

    const state = reactive({
      editing: false,
      editingData,
      previewImageUrl: '',
    }) as State

    watch(() => usrState.activities, () => {
      console.log('updated!')
      state.editingData = getEditingData()
    })

    const cancel = () => {
      state.editingData = getEditingData()
    }

    const save = () => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      api.updateActivity(state.editingData)
        .then(() => updateResource())
        .then(() => loading.close())
        .catch(() => loading.close())
    }

    const preview = () => {
      usrPreviewState.activity = JSON.parse(JSON.stringify(state.editingData))
      localStorage.setItem('resourcesPreview', JSON.stringify(usrPreviewState))
      window.open('/activities/Preview', '_blank')
    }

    const handleUpload = (promise: Promise<void>) => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      promise
        .then(() => loading.close())
        .catch(() => loading.close())
    }

    return {
      isNew,
      dmTemplate,
      state,
      addToArray,
      removeFromArray,
      cancel,
      save,
      preview,
      handleUpload,
    }
  },
})
